module.exports = __webpack_public_path__ + "assets/img/5cae-tl.svg";